import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'

import RouteInfoContext, {RouteInfoCtx} from './context'

const propTypes = {
  alternativeRoutes: PropTypes.objectOf(PropTypes.objectOf(PropTypes.string.isRequired).isRequired),
  currentRegion: PropTypes.string,
  currentLocale: PropTypes.string,
  children: PropTypes.node,
}
const defaultProps = {
  alternativeRoutes: undefined,
  currentRegion: undefined,
  currentLocale: undefined,
  children: null,
}

export type BasePathProviderProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const RouteInfoContextProvider: React.FC<BasePathProviderProps> = ({
  alternativeRoutes,
  currentRegion,
  currentLocale,
  children,
}) => {
  const value: RouteInfoCtx = {
    alternativeRoutes: alternativeRoutes ?? undefined,
    currentRegion: currentRegion ?? undefined,
    currentLocale: currentLocale ?? undefined,
  }

  return <RouteInfoContext.Provider value={value}>{children}</RouteInfoContext.Provider>
}

RouteInfoContextProvider.propTypes = propTypes
RouteInfoContextProvider.defaultProps = defaultProps

export default RouteInfoContextProvider
